import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';

export default class ModCollections extends Component {
	render () {
		let block 	= this.props.block;
		let clss 	= 'l-grid__col l-grid__col--m-4-12 l-grid__col--l-4-12';
		if (block.grid == 'large') {
			clss = 'l-grid__col l-grid__col--m-6-12';
		}
		return (
			<div className="l-block l-block--display-standard">
				<div className="c-thumbs c-thumbs--alt">
					<div className="l-content">
		    			<div className="l-grid">
		    				{block.collection.map((thumb,i) =>
								{
									return (
										<div className={clss}>
											<Link to={thumb.link} className="c-thumb-alt">
								   				<div className="c-thumb-alt__inner">
								   					<FadeIn duration={250}>
														{onload => (
															<img
																alt={thumb.title} 
																src={thumb.src} 
																srcSet={thumb.srcset} 
																onLoad={onload}
															/>
														)}
													</FadeIn>
								   				</div>
								   				<h4 className="c-thumb-alt__title" dangerouslySetInnerHTML={ {__html: thumb.title } }></h4>		
								   				<p className="c-thumb-alt__see-all" dangerouslySetInnerHTML={ {__html:"See all"}}></p>							   
								   			</Link>
								   		</div>
									)
								}
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}